/**
 * useReadOnly Hook
 * Returns true when the logged-in user is a frozen read-only demo viewer.
 * The backend is the source of truth (403 with code `read_only_demo` on any write);
 * this just lets pages hide prominent write buttons up front.
 */

import { useAuth } from '../context/AuthContext';

/** @returns {boolean} True if the current user is a read-only demo viewer. */
export const useReadOnly = () => {
  const { user } = useAuth();
  return user?.isReadOnlyDemo === true;
};

export default useReadOnly;
